import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const InventoryDesktop = dynamic(() => import('../../components/inventory/InventoryDesktop'), {
  loading: () => <Loading />,
})
const InventoryMobile = dynamic(() => import('../../components/inventory/InventoryMobile'), {
  loading: () => <Loading />,
})
const inventoryManagement = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Best Inventory Management Software Free With QueueBuster POS</title>
        <link rel="canonical" href="https://queuebuster.co/features/inventory-management-software" />
        <link rel="alternate" href="https://queuebuster.co/features/inventory-management-software" hrefLang="en-us" />
        <meta name="description" content="QueueBuster eStore: Build a Free Online Store or eCommerce website for Your Shop & Outlets. Quick setup, seamless transactions. Start selling online today!	Discover seamless customer management with QueueBuster's CRM & Loyalty Program features. Enhance loyalty, streamline communication & boost sales. Try it today!	QueueBuster's Inventory Management Software offers seamless real-time tracking solutions. Optimize stock levels and streamline operations effortlessly." />
        <meta property="og:title" content="QueueBuster Inventory Management Software for Real-Time Tracking Fee With POS Billing" />
        <meta property="og:description" content="Experience seamless inventory control with QueueBuster's Real-Time Tracking Software. Optimize stock levels, streamline operations, and enhance efficiency for your business." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG-Image_Inventory.jpg" />
        <meta property="og:url" content="https://queuebuster.co/features/inventory-management-software" />
      </Head>
      <SchemaTags page="inventory-management-software" />
      {mobileView ? <InventoryMobile /> : <InventoryDesktop />}
    </>
  )
}

export default inventoryManagement
